import { render, staticRenderFns } from "./UserMenuAdminPlus.vue?vue&type=template&id=18582522&scoped=true"
import script from "./UserMenuAdminPlus.vue?vue&type=script&lang=js"
export * from "./UserMenuAdminPlus.vue?vue&type=script&lang=js"
import style0 from "./UserMenuAdminPlus.vue?vue&type=style&index=0&id=18582522&prod&scoped=true&lang=css"
import style1 from "./UserMenuAdminPlus.vue?vue&type=style&index=1&id=18582522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18582522",
  null
  
)

export default component.exports